import { observer }  from 'mobx-react-lite';
import ApiModel      from '@widesk-core/models/ApiModel';
import Text          from '@widesk-ui/components/Text';
import { TextProps } from '@widesk-ui/components/Text';
import Value         from '@widesk-ui/components/Value';
import useTheme      from '@widesk-ui/hooks/useTheme';

type Mode = 'createdBy' | 'updatedBy';

const By = observer((props: { mode?: Mode, model: ApiModel } & TextProps) => {
	const { mode, model } = props;

	const theme = useTheme();

	let at = (model as any)['createdAt'];
	let by = (model as any)['createdBy'];

	switch (mode) {
		case 'updatedBy':
			at = (model as any)['updatedAt'];
			by = (model as any)['updatedBy'];
			break;
	}

	let text = `Le ${at.format('L [à] LT')}`;

	if (by.isLoaded && by.fullName) {
		text += ` par ${by.fullName}`;
	}

	return <Text {...props} color={props.color || theme.colorTextDescription}><Value loading={by.isLoading} value={text} /></Text>;
});

export default By;
